import { gql } from "@apollo/client";

export const CREATE_USER = gql`
  mutation CreateUser($email: String!, $username: String!, $password: String!) {
    createUser(email: $email, username: $username, password: $password) {
      user {
        id
        email
        username
        groups {
          name
        }
      }

      sessionKey
    }
  }
`;

export const WHO_AM_I = gql`
  query {
    whoAmI {
      username
    }
  }
`;

export const CREATE_CUSTOMER = gql`
  mutation CreateCustomer {
    createCustomer {
      customer {
        id
      }
    }
  }
`;

export const CREATE_SUBSCRIPTION = gql`
  mutation CreateSubscription(
    $customerId: String!
    $paymentMethodId: String!
    $priceId: String!
    $promoCode: String
  ) {
    createSubscription(
      customerId: $customerId
      paymentMethodId: $paymentMethodId
      priceId: $priceId
      promoCode: $promoCode
    ) {
      subscription {
        status
      }
    }
  }
`;
